import React from 'react';
import PropTypes from 'prop-types';

const SocialBtn = ({logo, label, onClick}) => (
  <div
    className="d-flex justify-content-center align-items-center cursor-pointer bg-white border border-light p-3"
    style={{borderRadius: '16px'}}
    onClick={onClick}
  >
    <img
      src={logo}
      alt={label}
      title={label}
      width="32px"
      height="32px"
    />
  </div>
);

SocialBtn.defaultProps = {
  isFirst: false
};

SocialBtn.propTypes = {
  logo: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isFirst: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

export default SocialBtn;
